import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Observable, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { LayoutService } from 'src/app/services/layout.service';
import { IMenuWrapper, ICustomMenuItem } from 'src/app/services/menu/menu.models';
import { MenuService } from 'src/app/services/menu/menu.service';
import { BaseComponent } from '../base.component';


@AutoUnsubscribe()
@Component({
    selector: 'app-menu',
    template: `
        <ul app-submenu [item]="menuItems" [root]="true" class="ultima-menu ultima-main-menu clearfix"
            [reset]="reset" [visible]="true" [parentActive]="true"></ul>
    `
})
export class AppMenuComponent extends BaseComponent implements OnDestroy {

    @Input() reset: boolean;

    @Input('type')
    public type: string;


    menuWrapper$: Observable<IMenuWrapper>;
    menuItems: ICustomMenuItem[];
    currentMenuSubscription: Subscription;

    topMenuItems: ICustomMenuItem[];
    bottomMenuItems: ICustomMenuItem[];

    constructor(
        public menuService: MenuService,
        public layoutService: LayoutService
    ) {
        super();
        this.currentMenuSubscription = this.menuService.getCurrentMenuAsync().pipe(filter(_ => !!_))
        .pipe(switchMap(menuSettings => {
            return menuSettings && menuSettings.items();
        }))
        .subscribe(menuItems => {
            this.menuItems = menuItems;
            this.topMenuItems = menuItems.filter(menuItem => menuItem.position == null || menuItem.position === 'TOP');
            this.bottomMenuItems = menuItems.filter(menuItem => menuItem.position === 'TOP');
        });
    }

    ngOnDestroy() {
super.ngOnDestroy();
    }

}
